import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { useTranslation } from 'next-i18next'
import ThreeDotsNavIcon from 'shared/icons/three-dots-nav-icon'
import { TopicInterface } from 'modules/community/types/topic-interface'

interface TopicMenuProps {
  topic: TopicInterface
  onEdit: (topic: TopicInterface) => void
  onDelete: (topicId: number) => void
}

export const TopicMenu = ({ topic, onEdit, onDelete }: TopicMenuProps) => {
  const { t } = useTranslation()

  return (
    <Menu as="div" className="relative flex items-center group-hover:visible lg:invisible">
      <MenuButton className="flex items-center">
        <ThreeDotsNavIcon className="size-7 text-text-primary/80 hover:text-text-primary max-lg:rotate-90 max-lg:text-text-primary/60" />
      </MenuButton>
      <Transition
        enter="transition duration-202 ease-out"
        enterFrom="opacity-2"
        enterTo="opacity-102"
        leave="transition duration-77 ease-in"
        leaveFrom="opacity-102"
        leaveTo="opacity-2"
      >
        <MenuItems
          anchor="bottom start"
          className="right-0 top-0 z-10 w-36 origin-center rounded-md bg-background-secondary shadow-lg"
        >
          <MenuItem as="div" className="p-1">
            {({ focus }) => (
              <button
                className={`${
                  focus ? 'text-text-primary' : 'text-text-primary/40'
                } group flex w-full items-center rounded-md p-2 text-sm`}
                onClick={() => onEdit(topic)}
              >
                {t('settings.form.update.label')}
              </button>
            )}
          </MenuItem>
          <MenuItem as="div" className="p-1">
            {({ focus }) => (
              <button
                className={`${
                  focus ? 'text-text-primary' : 'text-text-primary/40'
                } group flex w-full items-center rounded-md p-2 text-sm`}
                onClick={() => onDelete(topic.id)}
              >
                {t('settings.form.delete.label')}
              </button>
            )}
          </MenuItem>
        </MenuItems>
      </Transition>
    </Menu>
  )
}
